import { render, staticRenderFns } from "./add.vue?vue&type=template&id=1ffea42a&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=1ffea42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffea42a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffea42a')) {
      api.createRecord('1ffea42a', component.options)
    } else {
      api.reload('1ffea42a', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=1ffea42a&scoped=true&", function () {
      api.rerender('1ffea42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/goodsspu/add.vue"
export default component.exports